import { FilterAlt } from '@mui/icons-material';
import { Grid, IconButton, Switch } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { cloneDeep } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { SearchContext } from '../../contexts/SearchContext';
import { IMaterialItem, ISearchFilterDialogProps } from '../../interfaces';


export const SearchFilterDialog: React.SFC<ISearchFilterDialogProps> = ({
    label,
    propertyName,
    filteredValues,
    ...props
}: ISearchFilterDialogProps) => {

    const isActive = () => {

        return filteredValues ? filteredValues.length > 0 : false;

    }

    const onCancel = () => {

        setOpen(false);
    }

    const [open, setOpen] = useState(false);

    const [availableFilters, setAvailableFilters] = useState<(string | number | null)[]>([]);

    const getSelectedFilters = () => {
        let option = searchContext.resultOptions.filter(x => x.propertyName === propertyName)[0];
        if (option && option.filteredValues) {
            return option.filteredValues;
        }

        return [] as string[];
    }

    const getLabel = (value: number | string | null) => {


        if (value === null || value === undefined) return "";

        if (typeof (value) === "number")
            return value.toString();

        if (value.match(/^\d{4}-\d{2}-\d{2}T/))
            return new Date(value).toLocaleDateString("en-GB");

        return value;
    }



    const toggleFilter = (value: string | number | null) => {

        var options = cloneDeep(searchContext.resultOptions);

        options.forEach(option => {
            if (option.propertyName === propertyName) {

                if (option.filteredValues) {
                    if (option.filteredValues.includes(value)) {
                        option.filteredValues = option.filteredValues.filter(x => x !== value)
                    } else {
                        option.filteredValues.push(value);
                    }

                } else option.filteredValues = [value];
            }
        });
        searchContext.setResultOptions(options);
    }

    const toggleAll = () => {

        let fv: (string | number | null)[] | undefined = [];

        if (getSelectedFilters().length === 0) {
            fv = availableFilters;
        }

        var options = cloneDeep(searchContext.resultOptions);

        options.forEach(option => {
            if (option.propertyName === propertyName) {
                option.filteredValues = fv;
            }
        });

        searchContext.setResultOptions(options);

    }

    const searchContext = useContext(SearchContext);

    useEffect(() => {

        let values: any[] = [];

        searchContext.apiResults?.forEach(result => {
            result.materials?.map((x: any) => x[propertyName])
                .forEach(y => values.push(y));
        });


        //get value of IMaterialItems
        let flatValues: (string | number)[] = [];
        values.forEach(v => {


            if (v === null || v === undefined || v.length === 0)
                return;

            if (v?.id !== undefined)
                flatValues.push(v.value);
            else if (Array.isArray(v)) {

                v.forEach((x: IMaterialItem) => {

                    //bit hacky but captures the note 
                    if (label.toLowerCase() === "notes")
                        x.value = (x as any).note;

                    flatValues.push(x.value as string);
                })
            }
            else flatValues.push(v);
        });

        //we only want unique values
        flatValues = Array.from(new Set(flatValues));
        setAvailableFilters(flatValues);

    }, [searchContext.results, searchContext.resultOptions])// eslint-disable-line react-hooks/exhaustive-deps


    return (
        <span>
            <IconButton
                onClick={() => setOpen(true)}
                color={isActive() ? "primary" : "default"}
                sx={{ opacity: isActive() ? 1 : 0.5 }}
            >
                <FilterAlt />
            </IconButton>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="xs"
            >

                <DialogTitle>
                    Filter {label}
                </DialogTitle>
                <DialogContent>
                    <p>Show results with {label} containing</p>
                    {availableFilters.map(option => {

                        let prefix = label.startsWith("Value Estimate") ? "£" : "";
                        let suffix = label === "Weight Estimate" ? "kg" : "";

                        return (
                            <Grid container alignItems="center" key={option}>
                                <Grid item xs={2}>
                                    <Switch
                                        checked={!getSelectedFilters().includes(option)}
                                        onChange={() => toggleFilter(option)}
                                    />
                                </Grid>
                                <Grid item xs={10}>
                                    <strong> {prefix + getLabel(option) + suffix}</strong>
                                </Grid>
                            </Grid>
                        )
                    })}
                    <Grid container alignItems="center"><Grid item xs={2}>
                        <Switch
                            checked={getSelectedFilters().length === 0}
                            onChange={toggleAll}
                        />
                    </Grid><Grid item xs={10}><strong>show all</strong></Grid></Grid>

                </DialogContent>
                <DialogActions>

                    <Button onClick={onCancel}>Close</Button>

                </DialogActions>
            </Dialog>
        </span>
    );
}